/**
 * Backend ba'zan nisbiy yo'l qaytaradi (/storage/...). Brauzer <img> uchun to'liq URL kerak.
 */
import { buildAbsoluteUrl } from '../config/apiConfig';

export function resolveMediaUrl(url) {
  let u = String(url ?? '').trim();
  if (!u) return '';
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith('//')) return `https:${u}`;
  if (u.startsWith('/')) return buildAbsoluteUrl(u);
  /* Backend ba'zan `storage/...` yoki `public/...` (slashsiz) yuboradi */
  if (/^(storage|uploads|public)\//i.test(u)) return buildAbsoluteUrl(`/${u}`);
  return u;
}
